<template>
  <div class="wrapper">
    <div class="vote">
        <div class="vote-action d-flex justify-content-center">
            <button type="button"
                class="btn btn-primary mr-5 btn-lg"
                @click="startVote()"
                :disabled="statusVote != notStartYet"
                :title="getTitleStatusVote()"
                >
                    {{$t('summer_trip.label_start')}}
                </button>
            <button type="button"
                class="btn btn-warning btn-lg"
                 @click="endVote()"
                :disabled="statusVote != onTime"
                :title="getTitleStatusVote()"
            >
                {{$t('summer_trip.label_end')}}
            </button>
             <button type="button"
                class="btn btn-danger ml-5 btn-lg"
                 @click="reset()"
                v-if="statusVote != notStartYet"
                :title="getTitleStatusVote()"
            >
                {{$t('summer_trip.label_reset')}}
            </button>
        </div>
        <div v-if="statusVote != notStartYet">
            <div class="vote-time d-flex justify-content-center mt-3">
                <label for="" class="mr-2">{{$t('summer_trip.label_time_started_at')}}:</label>
                <div class="time-start">{{startTimeVote}}</div>
            </div>
            <div class="vote-time d-flex justify-content-center" v-if="statusVote == finished">
                <label for="" class="mr-2">{{$t('summer_trip.label_time_finished_at')}}:</label>
                <div class="time-end">{{endTimeVote ? endTimeVote : null}}</div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SummerTripVote",
  data(){
    return {
        notStartYet: 1,
        onTime: 2,
        finished: 3
    }
  },
  created() {
    this.getVoteStatus({year:2022,period:1})
  },
  computed: {
    ...mapGetters({
        statusVote: "summer-trip-vote/statusVote",
        startTimeVote: "summer-trip-vote/startVote",
        endTimeVote: "summer-trip-vote/endVote"
    })
  },
  methods: {
    ...mapActions("summer-trip-vote", ["start", "end", "getVoteStatus","resetVote"]),
    ...mapActions("layout", ["setLoading"]),

    async startVote(){
        this.$confirm(
        this.$t("summer_trip.popup.label_confirm_start_vote_text"),
        this.$t("summer_trip.popup.label_confirm_start_vote_title"),
        this.$t("summer_trip.popup.label_confirm_vote_submit"),
        this.$t("summer_trip.popup.label_confirm_vote_cancel"),
        "danger"
      ).then((value) => {
        if (value) {
                this.setLoading(true);
                this.start({year: 2022,period: 1})
                    .then(() => {
                        this.getVoteStatus({year:2022,period:1});
                        let message = this.$t("summer_trip.popup.reset_successfully");
                        this.$toast(message, null, 2000, "b-toaster-top-center", "success");
                        this.setLoading(false);
                    })
                    .catch((e) => {
                        console.log(e);
                        this.setLoading(false);
                    });
            }
      });
    },

    async endVote(){
        this.$confirm(
        this.$t("summer_trip.popup.label_confirm_end_vote_text"),
        this.$t("summer_trip.popup.label_confirm_end_vote_title"),
        this.$t("summer_trip.popup.label_confirm_vote_submit"),
        this.$t("summer_trip.popup.label_confirm_vote_cancel"),
        "danger"
      ).then((value) => {
        if (value) {
            this.setLoading(true);
            this.end({year: 2022,period: 1})
                .then(() => {
                setTimeout(this.delayGetStatusVote,1000)
                })
                .catch((e) => {
                    console.log(e);
                    this.setLoading(false);
                });
            }
      });
    },
    async reset(){
        this.$confirm(
        this.$t("summer_trip.popup.label_confirm_reset_vote_text"),
        this.$t("summer_trip.popup.label_confirm_reset_vote_title"),
        this.$t("summer_trip.popup.label_confirm_vote_submit"),
        this.$t("summer_trip.popup.label_confirm_vote_cancel"),
        "danger"
      ).then((value) => {
        if (value) {
            this.setLoading(true);
            this.resetVote({year: 2022,period: 1})
                .then(() => {
                    this.getVoteStatus({year:2022,period:1});
                    let message = this.$t("summer_trip.popup.reset_successfully");
                    this.$toast(message, null, 2000, "b-toaster-top-center", "success");
                    this.setLoading(false);
                })
                .catch((e) => {
                    console.log(e);
                    this.setLoading(false);
                });
            }
      });
    },
    getTitleStatusVote(){
        if(this.statusVote == this.notStartYet){
            return this.$t('summer_trip.time_vote_not_start_yet');
        }
        if(this.statusVote == this.onTime){
            return this.$t('summer_trip.time_vote_started');
        }
        if(this.statusVote == this.finished){
            return this.$t('summer_trip.time_vote_finished');
        }
    },
    delayGetStatusVote(){
        this.getVoteStatus({year:2022,period:1});
        let message = this.$t("summer_trip.popup.end_successfully");
        this.$toast(message, null, 2000, "b-toaster-top-center", "success");
        this.setLoading(false);
    }
  }

}
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 100%;
        padding: 15px;
    }
    .vote {
        width: 100%;
        padding: 15px;
        background-color: #fff;
    }
</style>
